(function($) {

    $(document).ready(function() {
      $('.product-media--thumbs').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        prevArrow: ' <svg class="icon--root slick-prev icon--chevron-left" viewBox="0 0 12 20"><path d="M2.648 10l8.613-8.614L9.99.114.102 10l9.887 9.886 1.272-1.272z" fill-rule="nonzero" /></svg>' ,
        nextArrow: '<svg class="icon--root slick-next icon--chevron-right" viewBox="0 0 12 20"><path d="M8.716 10L.102 18.614l1.273 1.272L11.261 10 1.375.114.102 1.386z" fill-rule="nonzero" /></svg>',
        dots: false,
        asNavFor: '.product-image-list',
        focusOnSelect: true
        
      });
    
      $('.product-image-list').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        // asNavFor: '.product-media--thumbs',
        dots: false,
        arrows: false,
        infinite: false,
        focusOnSelect: true,
        responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            slidesToShow: 1.05,
            slidesToScroll: 1,
          }
        }
        ]
      });

      var cbSelectedImputs = $('.product-form--variants .radios--root .radios--input:checked');
      if (cbSelectedImputs.length > 0) {
        $('.product-media--thumbs').slick('slickUnfilter');
        $('.product-image-list').slick('slickUnfilter');

        var cbCombinationName = '';
        $(cbSelectedImputs).each(function () {
          cbCombinationName += ' ' + $(this).val();
        });
        cbCombinationName = cbCombinationName.trim().toLowerCase();

        var cbVariantThumbs = [];
        $('.product-media--thumbs .slick-slide img').each(function() {
          var img_alt = $(this).attr('alt').toLowerCase();
          var img_alt_parts = img_alt.split(':');
          var slidePosition = $(this).parents('.slick-slide').data('slick-index');
          $(img_alt_parts).each(function () {
            if (this.trim() === cbCombinationName) {
              cbVariantThumbs.push('[data-slick-index="' + slidePosition + '"]');
            }
          });
        });

        if (cbVariantThumbs.length > 0) {
          $('.product-media--thumbs').slick('slickFilter',cbVariantThumbs.join(', '));
          $('.product-media--thumbs').slick('slickGoTo', 0);
        }

        var cbVariantImages = [];
        $('.product-image-list .slick-slide img').each(function() {
          var img_alt = $(this).attr('alt').toLowerCase();
          var img_alt_parts = img_alt.split(':');
          var slidePosition = $(this).parents('.slick-slide').data('slick-index');
          $(img_alt_parts).each(function () {
            if (this.trim() === cbCombinationName) {
              cbVariantImages.push('[data-slick-index="' + slidePosition + '"]');
            }
          });
        });

        if (cbVariantImages.length > 0) {
          $('.product-image-list').slick('slickFilter',cbVariantImages.join(', '));
          $('.product-image-list').slick('slickGoTo', 0);
        }

        $('.product-media--thumbs .slick-slide').click(function () {
          var slickIndex = $(this).data('slick-index');
          $('.product-image-list').slick('slickGoTo', parseInt(slickIndex));
        });
      }


//       $('#color-chart').on('click',function(){
//   console.log('asdas')
//   $('.product-add-modal').clone().appendTo($('.modal--window').find('.modal--content'));
//   $('.modal--window').find('.modal--content').addClass('active');
//   $('.modal--window').find('.modal--mask').fadeIn();
//   $('.modal--window').show();
// })
    if (window.matchMedia("(max-width: 767px)").matches) {
      $('.accordions').appendTo('.product-info')
    }
    
      
    });
})(jQuery);